/**
 * 百度统计统一入口
 *
 * 跨平台 API，内部根据平台条件编译分发到不同的 SDK：
 * - H5 端：baidu-tongji.ts (百度统计 hm.js，后端配置驱动)
 * - 小程序端：baidu-mtj.ts (百度移动统计 mtj-wx-sdk)
 * - App 端：使用 uni-app 内置 uni统计
 */

// ⚠️ initBaiduMtj / trackMpEvent 已临时关闭（小程序主包体积超限），恢复见 docs/baidu-analytics-guide.md
import { trackPageEnd, trackPageStart } from './baidu-mtj';
import { initBaiduTongji, trackEvent as trackH5Event } from './baidu-tongji';

/**
 * 初始化所有平台的百度统计
 * @param options.baiduHmUrl - H5 端百度统计 hm.js URL (来自后端接口)
 */
export function initAnalytics(options?: { baiduHmUrl?: string }): void {
  // #ifdef H5
  initBaiduTongji(options?.baiduHmUrl);
  // #endif

  // #ifdef MP-WEIXIN
  // ⚠️ 小程序端百度统计已临时关闭（主包体积超限）。恢复：还原本文件顶部 import 并取消下行注释。
  // initBaiduMtj();
  // #endif
}

/**
 * 统一事件上报 (跨平台)
 * @param name - 事件名称
 * @param label - 事件标签
 * @param attributes - 事件属性 (App/小程序端使用)
 */
export function trackEvent(name: string, label?: string, attributes?: Record<string, any>): void {
  // #ifdef H5
  trackH5Event('custom', name, label);
  // #endif

  // #ifdef MP-WEIXIN
  // ⚠️ 小程序端百度统计已临时关闭（主包体积超限）。恢复：还原本文件顶部 import 并取消下行注释。
  // trackMpEvent(name, { ...attributes, ...(label ? { label } : {}) });
  // #endif
}

// 导出 App 端页面追踪 (供路由拦截器和 App.vue 使用)
export { trackPageEnd, trackPageStart };
